import React from 'react';
import classNames from 'utils/classNames';
import PropTypes from 'prop-types';
import { withErrorBoundary } from 'react-error-boundary';
import ErrorComponent from 'components/common/ErrorComponent';

const Label = ({children, htmlFor, className=''}) => {
	return (
		<label
			htmlFor="htmlFor"
			className={classNames(
				"text-[#4B5264] font-semibold text-base mb-10px block"
			)}>
			{children}
		</label>
	);
};
Label.propTypes = {
	children: PropTypes.node,
	htmlFor: PropTypes.string,
	className: PropTypes.string,
}
export default withErrorBoundary(Label, {
	FallbackComponent: ErrorComponent
})